import { render, staticRenderFns } from "./GprStatusItem.vue?vue&type=template&id=2026b2de&scoped=true"
import script from "./GprStatusItem.vue?vue&type=script&lang=js"
export * from "./GprStatusItem.vue?vue&type=script&lang=js"
import style0 from "./GprStatusItem.vue?vue&type=style&index=0&id=2026b2de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2026b2de",
  null
  
)

export default component.exports